import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoadingMessageComponent } from './loading-message/loading-message.component';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { SignNowLoginButtonComponent } from './signnow-login-button/signnow-login-button.component';
import { DataBindingBaseFormComponent } from './data-binding-form/data-binding-base-form/data-binding-base-form.component';
import { DataBindingPopupFormComponent } from './data-binding-form/data-binding-popup-form/data-binding-popup-form.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    providers: [],
    declarations: [
        LoadingMessageComponent,
        ModalPopupComponent,
        SignNowLoginButtonComponent,
        DataBindingBaseFormComponent,
        DataBindingPopupFormComponent
    ],
    exports: [
        LoadingMessageComponent,
        ModalPopupComponent,
        SignNowLoginButtonComponent,
        DataBindingBaseFormComponent,
        DataBindingPopupFormComponent
    ]
})
export class SharedComponentsModule {}
